import api from './index';
import type { Vehicle } from './vehicles';

export interface IncidentReporter {
  id: number;
  name: string;
  email: string;
  role: string;
}

export interface Incident {
  id: number;
  vehicle_id: number;
  date: string; // ISO string
  time: string; // e.g. '14:30'
  description: string;
  created_at: string;
  images?: IncidentImage[];
  location: string;
  involved_employees?: number[];
  reported_by_user_id?: number | null;
  reported_by_user?: IncidentReporter | null;
  vehicle?: Pick<Vehicle, 'id' | 'brand' | 'license_plate' | 'description'>;
}

export interface IncidentImage {
  id: number;
  incident_id: number;
  url: string;
  created_at: string;
}

export interface CreateIncidentData {
  vehicle_id: number;
  date: string;
  time: string;
  description: string;
  location: string;
  involved_employees?: number[];
  images?: string[];
}

export type UpdateIncidentData = Partial<CreateIncidentData>;

const incidentsUrl = '/incidents';

export const incidentService = {
  async getAll(): Promise<Incident[]> {
    const response = await api.get(incidentsUrl);
    return response.data;
  },
  async create(data: CreateIncidentData): Promise<Incident> {
    const response = await api.post(incidentsUrl, data);
    return response.data;
  },
  async update(id: number, data: UpdateIncidentData): Promise<Incident> {
    const response = await api.put(`${incidentsUrl}/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`${incidentsUrl}/${id}`);
  },
};
